module.exports = __webpack_public_path__ + "img/bg-main.d42845f9.jpg";